import { pathOr } from 'ramda'
import { MetadataState } from './reducer'
import { CoreUxOrderStatus } from 'src/componentsV2/CoreUX/types/coreUxOrder.types'
import { Cutoff } from './actions'

export const getMetadata = (state): MetadataState =>
  pathOr(
    { date: null, orderStatus: null, displayDate: null, cutoff: null },
    ['metadata'],
    state
  )

export const getOrderStatus = (state): CoreUxOrderStatus | null =>
  pathOr(null, ['metadata', 'orderStatus'], state)

export const getDate = (state): string | null =>
  pathOr(null, ['metadata', 'date'], state)

export const getDisplayDate = (state): string | null =>
  pathOr(null, ['metadata', 'displayDate'], state)

export const getCutoff = (state): Cutoff | null =>
  pathOr(null, ['metadata', 'cutoff'], state)
